/*
 * Pince-moi : message d'expédition du jour, calculé à l'heure de Paris.
 * Cible les éléments [data-pm-cutoff] (bloc « Pince-moi · Réassurance »).
 *   data-cutoff-hour : heure limite (ex. 14)
 *   data-weekends    : "true" si expéditions le samedi et le dimanche
 * Se met à jour chaque minute et après un changement de variante (le thème re-rend la fiche).
 */
(function () {
  'use strict';

  var DAYS = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];

  function parisNow() {
    try {
      var parts = new Intl.DateTimeFormat('fr-FR', {
        timeZone: 'Europe/Paris',
        weekday: 'short',
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
      }).formatToParts(new Date());
      var map = {};
      parts.forEach(function (p) {
        map[p.type] = p.value;
      });
      var wd = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'].indexOf(map.weekday);
      return { day: wd, hour: parseInt(map.hour, 10), minute: parseInt(map.minute, 10) };
    } catch (e) {
      var d = new Date();
      return { day: d.getDay(), hour: d.getHours(), minute: d.getMinutes() };
    }
  }

  function isShipDay(day, weekends) {
    return weekends || (day !== 0 && day !== 6);
  }

  function nextShipDay(day, weekends) {
    for (var i = 1; i <= 7; i++) {
      var d = (day + i) % 7;
      if (isShipDay(d, weekends)) return { day: d, offset: i };
    }
    return { day: (day + 1) % 7, offset: 1 };
  }

  function message(el) {
    var cutoff = parseInt(el.getAttribute('data-cutoff-hour'), 10);
    if (isNaN(cutoff)) cutoff = 14;
    var weekends = el.getAttribute('data-weekends') === 'true';
    var now = parisNow();
    if (now.day < 0) return null;

    if (isShipDay(now.day, weekends) && now.hour < cutoff) {
      var minutesLeft = cutoff * 60 - (now.hour * 60 + now.minute);
      var h = Math.floor(minutesLeft / 60);
      var m = minutesLeft % 60;
      if (minutesLeft <= 180) {
        var left = h > 0 ? h + ' h ' + (m < 10 ? '0' : '') + m : m + ' min';
        return 'commandez dans les ' + left + ', elle part aujourd’hui';
      }
      return 'commandez avant ' + cutoff + 'h, elle part aujourd’hui';
    }

    var next = nextShipDay(now.day, weekends);
    var when = next.offset === 1 ? 'demain' : DAYS[next.day];
    return 'commandée maintenant, elle part ' + when;
  }

  function update() {
    var nodes = document.querySelectorAll('[data-pm-cutoff]');
    for (var i = 0; i < nodes.length; i++) {
      var text = message(nodes[i]);
      if (text && nodes[i].textContent.trim() !== text) nodes[i].textContent = text;
    }
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      update();
    });
  }

  function init() {
    update();
    window.setInterval(update, 60000);
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes.length) {
            schedule();
            return;
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
